import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getEnvVar } from '../../config/RuntimeConfig';

export type CaptchaProps = {
    lang: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
};

const ReCaptchaV3: React.FC<CaptchaProps> = ({ lang, children, style }) => {
  const siteKey = getEnvVar('RECAPTCHA_SITE_KEY') ?? '';
  const isRecaptchaDisabled = getEnvVar('DISABLED_RECAPTCHA') === "true" || !siteKey;

  if (isRecaptchaDisabled) {
    return style ? <div style={style}>{children}</div> : <>{children}</>;
  }

  const provider = (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      language={lang}
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
      }}
      container={{
        // optional to render inside custom element
        parameters: {
          badge: 'inline', // optional, default undefined
          theme: 'dark', // optional, default undefined
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );

  return style ? <div style={style}>{provider}</div> : provider;
};

export default ReCaptchaV3;
